<script>
import {IMaskDirective} from 'vue-imask';
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import CallbackErrorMessage from "@js/components/Sections/Callback/Components/CallbackErrorMessage.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import IconUser from "@js/components/Icons/IconUser.vue";
import PrivacyPolicyAgreementLink from "@js/components/Sections/Contacts/Components/PrivacyPolicyAgreementLink.vue";

export default {
    name: "ContactTopForm",
    components: {PrivacyPolicyAgreementLink, IconUser, IconPhone, CallbackErrorMessage, SpinnerIndicator},
    directives: {
        imask: IMaskDirective
    },
    data() {
        return {
            phoneMask: {
                mask: '+7 (000) 000-00-00',
            },
        }
    },
    methods: {
        updatePhone(newPhone) {
            this.callbackStore.forms.contacts_top_form.data.phone = newPhone;
        },
    },
    setup() {
        const callbackStore = useCallbackFormsStore()

        return {callbackStore}
    }
}
</script>

<template>
    <div class="flex justify-center">
        <div class="w-full bg-[#F0F0FA] rounded-2xl md:rounded md:rounded-br-[64px] md:rounded-tl-[64px] max-w-[600px] max-h-[750px] shadow">
            <div class="ps-5 pe-5 pt-8 pb-8 md:p-14">
                <p class="text-xl md:text-3xl text-[#2D2D2D] font-bold text-center">
                    Заполните короткую форму
                </p>
                <div class="mt-10">
                    <div class="flex flex-col gap-5 md:gap-8 w-full mb-5">
                        <div>
                            <div class="relative w-full lg:w-auto">
                                <div
                                    class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                                    <IconPhone class="w-6 h-6 text-gray-500"/>
                                </div>
                                <input type="tel"
                                       @keyup="updatePhone($event.target.value)"
                                       :value="callbackStore.forms.contacts_top_form.data.phone"
                                       v-imask="phoneMask"
                                       id="ctf_phone" aria-describedby="helper-text-explanation"
                                       class="bg-transparent border border-gray-300 text-gray-900 text-md rounded-lg focus:divide-indigo-600 focus:border-indigo-600 block w-full ps-10 p-4"
                                       :class="[callbackStore.forms.contacts_top_form.errors && callbackStore.forms.contacts_top_form.errors['phone'] ? 'border-red-500' : '']"
                                       placeholder="+7 (___) ___-__-__" required/>
                            </div>
                            <CallbackErrorMessage :error="callbackStore.forms.contacts_top_form.errors"
                                                  :error-msg="'phone'"/>
                        </div>
                        <div>
                            <div class="relative w-full lg:w-auto">
                                <div
                                    class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                                    <IconUser class="w-6 h-6 text-gray-500"/>
                                </div>
                                <input v-model="callbackStore.forms.contacts_top_form.data.full_name"
                                       type="text" id="ctf_full_name"
                                       aria-describedby="helper-text-explanation"
                                       class="bg-transparent border border-gray-300 text-gray-900 text-md rounded-lg focus:divide-indigo-600 focus:border-indigo-600 block w-full ps-10 p-4"
                                       :class="[callbackStore.forms.contacts_top_form.errors && callbackStore.forms.contacts_top_form.errors['full_name'] ? 'border-red-500' : '']"
                                       pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                       placeholder="Как к вам обращаться?" required/>
                            </div>
                            <CallbackErrorMessage :error="callbackStore.forms.contacts_top_form.errors"
                                                  :error-msg="'full_name'"/>
                        </div>
                        <div class="relative w-full lg:w-auto">
                            <textarea v-model="callbackStore.forms.contacts_top_form.data.comment"
                                      id="message" rows="4"
                                      class="bg-transparent border border-gray-300 text-gray-900 text-md rounded-lg focus:divide-indigo-600 focus:border-indigo-600 block w-full p-4"
                                      placeholder="Оставьте комментарий..."></textarea>
                        </div>
                        <div class="relative w-full lg:w-auto flex justify-center">
                            <button @click.prevent="callbackStore.send(callbackStore.forms.contacts_top_form)"
                                    type="button"
                                    class="flex justify-center items-center text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-full text-sm px-16 py-2.5 focus:outline-none transition w-full">
                                <span class="text-base">
                                    Оставить заявку
                                </span>
                                <SpinnerIndicator v-if="callbackStore.forms.contacts_top_form.sending"
                                                  class="w-6 h-6 ms-2"/>
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center">
                        <PrivacyPolicyAgreementLink class="md:max-w-[80%]"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
